import React from 'react'

const COMPACT_LOGO_PATTERN = /hpe|nvidia|hp_enterprise|hp-enterprise/

const getPartnerLogoBoxClass = (imageUrl) => {
     const src = (imageUrl || '').toLowerCase()
     if (COMPACT_LOGO_PATTERN.test(src)) {
          return 'partner-logo-box partner-logo-box--compact'
     }
     return 'partner-logo-box partner-logo-box--boosted'
}

const handlePartnerLogoLoad = (event) => {
     const img = event.currentTarget
     const box = img.closest('.partner-logo-box')
     if (!box || box.classList.contains('partner-logo-box--compact')) {
          return
     }

     box.classList.remove(
          'partner-logo-box--boosted',
          'partner-logo-box--boosted-lg',
     )

     const { naturalWidth, naturalHeight } = img
     if (!naturalWidth || !naturalHeight) {
          box.classList.add('partner-logo-box--boosted')
          return
     }

     const aspectRatio = naturalWidth / naturalHeight
     if (aspectRatio < 1.35 || aspectRatio > 3.5) {
          box.classList.add('partner-logo-box--boosted-lg')
          return
     }

     box.classList.add('partner-logo-box--boosted')
}

const setPartnerLogoRef = (node) => {
     if (node?.complete && node.naturalWidth) {
          handlePartnerLogoLoad({ currentTarget: node })
     }
}

const Partners = ({ title, data, largeLogos = false }) => {
     return (
          <div className={`esteemed-partners section-space${largeLogos ? " esteemed-partners--large" : ""}`}>
               <div className="container">
                    <h2>{title}</h2>
                    <ul className="esteemed-icon">
                         {data?.sort((a, b) => a.order - b.order)
                              .map((partner) => (
                                   <li key={partner.id}>
                                        {largeLogos ? (
                                             <div className={getPartnerLogoBoxClass(partner.image)}>
                                                  <img
                                                       ref={setPartnerLogoRef}
                                                       src={partner.image}
                                                       alt={partner.altText}
                                                       loading="lazy"
                                                       onLoad={handlePartnerLogoLoad}
                                                  />
                                             </div>
                                        ) : (
                                             <img
                                                  src={partner.image}
                                                  alt={partner.altText}
                                                  height={44}
                                                  width={173}
                                                  loading="lazy"
                                             />
                                        )}
                                   </li>
                              ))}
                    </ul>
               </div>
          </div>
     )
}

export default Partners
